// extracted by mini-css-extract-plugin
export default {"upload":"SoundTab_upload__sjiAK"};